import HelpInfo from 'components/HelpInfo/HelpInfo';
import { useTranslation } from 'react-i18next';

export default function HelpInfoDefault() {
  const { t } = useTranslation();
  return (
    <HelpInfo
      title={t('help_info:title')}
      text={t('help_info:text')}
      dataTest="helpInfoDefault"
    />
  );
}
